import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Location } from '@angular/common';

@Component({
  selector: 'app-finalize-modal',
  templateUrl: './finalize-modal.component.html',
  styleUrls: ['./finalize-modal.component.scss'],
})
export class FinalizeModalComponent implements OnInit {
  isLoading = true;
  Errors = null;
  emplyees = null;
  mode = null;
  Success = null;
  titles = null;
  specials = null;
  depts = null;
  cities = null;
  countries = null;
  cats = null;
  nats = null;
  filterddata: any = [];
  private _searchText: string;
  result_id: any;
  initializer_userid: any;
  finalizer_userid: any;
  comment = '';
  showComment = false;
  otherData;
  @Output() successEvent = new EventEmitter<boolean>();
  get searchText(): string {
    return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filterddata = this.filterdata(value);
  }

  filterdata(searchString: string) {
    return this.emplyees.filter(
      (log) => log.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1
    );
  }

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService,
    private location: Location,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
    console.log(this.data.id);
    this.auth.getTitle().subscribe(
      (resSuccess) => {
        this.titles = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getSpecials().subscribe(
      (resSuccess) => {
        this.specials = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getDept().subscribe(
      (resSuccess) => {
        this.depts = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getCity().subscribe(
      (resSuccess) => {
        this.cities = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getcountry().subscribe(
      (resSuccess) => {
        this.countries = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getCategories().subscribe(
      (resSuccess) => {
        this.cats = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getEmployees().subscribe(
      (resSuccess) => {
        this.emplyees = resSuccess;
        console.log(this.emplyees);
        this.filterddata = this.emplyees;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  finalizerId(id) {
    this.finalizer_userid = id;
    console.log(this.finalizer_userid);
    if (this.finalizer_userid && this.initializer_userid) {
      this.showComment = true;
    }
  }
  initializerId(id) {
    this.initializer_userid = id;
    console.log(this.initializer_userid);
    if (this.finalizer_userid && this.initializer_userid) {
      this.showComment = true;
    }
  }

  overideFinializer() {
    this.auth
      .postOverideFinializer(
        +this.data.id,
        this.initializer_userid,
        this.finalizer_userid,
        this.comment
      )
      .subscribe(
        (resSuccess) => {
          this.otherData = resSuccess;
          this.isLoading = false;

          if (this.otherData.success) {
            this.successEvent.emit(true);
            this.closeModal();
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            // window.location.reload();
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
  }
}
